var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-card",
    { staticClass: "hide-overflow", attrs: { flat: "", height: "100%" } },
    [
      _c(
        "Loading",
        {
          attrs: {
            visible: _vm.loading,
            message: "Caricamento ordini...",
            templateType: _vm.loadTemplateCorrente,
          },
        },
        [
          _c(
            "v-layout",
            { staticStyle: { "margin-bottom": "50px" }, attrs: { wrap: "" } },
            [
              _vm.userIsAdmin
                ? _c(
                    "v-flex",
                    {
                      staticStyle: { margin: "24px 24px 0px 24px" },
                      attrs: { xs12: "" },
                    },
                    [
                      _c("v-select", {
                        attrs: {
                          filled: "",
                          clearable: "",
                          "return-object": "",
                          items: _vm.fornitori,
                          "item-text": "nome",
                          label: "Fornitori",
                          hint: "Selezionare fornitore per visualizzare gli ordini",
                        },
                        model: {
                          value: _vm.fornitore,
                          callback: function ($$v) {
                            _vm.fornitore = $$v
                          },
                          expression: "fornitore",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.ordini && _vm.ordini.length > 0
                ? _c(
                    "v-flex",
                    { attrs: { xs12: "" } },
                    [
                      !_vm.vistaLista
                        ? _c("OrdiniCards", { attrs: { ordini: _vm.ordini } })
                        : _c("OrdiniList", {
                            attrs: {
                              "data-test": "lista-ordini",
                              ordini: _vm.ordini,
                            },
                          }),
                    ],
                    1
                  )
                : _c(
                    "v-flex",
                    { attrs: { xs12: "" } },
                    [
                      _c(
                        "v-alert",
                        {
                          staticStyle: { margin: "auto" },
                          attrs: { type: "info", value: true },
                        },
                        [_vm._v("Non ci sono ordini da visualizzare.")]
                      ),
                    ],
                    1
                  ),
              _c("div", { staticClass: "pagination text-xs-center" }, [
                _c("div", { staticClass: "pagination-text grey--text" }, [
                  _vm._v(" Ordini visualizzati: "),
                  _c("strong", [_vm._v(_vm._s(_vm.numTotOrdini))]),
                ]),
                _c(
                  "div",
                  { staticClass: "pagination-buttons" },
                  [
                    _c("v-pagination", {
                      attrs: { length: _vm.pageCount, disabled: _vm.loading },
                      model: {
                        value: _vm.page,
                        callback: function ($$v) {
                          _vm.page = $$v
                        },
                        expression: "page",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }